var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"money-gps"},[_c('img',{attrs:{"src":"https://moneygps.com.au/wp-content/uploads/2021/09/Group-58@2x.png"}}),_c('p',[_vm._v(" Willed is delighted to have moneyGPS as its partner, in offering clients access to the leading online Will service in the country ")])])
}]

export { render, staticRenderFns }